import api from "@/services/api";
import { ENDPOINTS_DISPUTES } from "@/services/endpoints";

export const listDisputes = () => api.get(ENDPOINTS_DISPUTES.list).then((r) => r.data);

export const createDispute = (payload) =>
  api.post(ENDPOINTS_DISPUTES.create, payload).then((r) => r.data);

export const getDispute = (id) => api.get(ENDPOINTS_DISPUTES.detail(id)).then((r) => r.data);

export const resolveDispute = (id, payload) =>
  api.post(ENDPOINTS_DISPUTES.resolve(id), payload).then((r) => r.data);

export const cancelDispute = (id) =>
  api.post(ENDPOINTS_DISPUTES.cancel(id)).then((r) => r.data);
